export enum BookingStateEnum {
  IN_PROGRESS = 1,
  IN_APPROVAL = 2,
  APPROVED = 3,
  BLOCKED = 4,
  CANCELLED = 5,
  REJECTED = 6,
  BOOKED = 9,
  FAILED = 11,
}
